import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, computed, inject, input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
import { AppCommonModule } from 'src/app/common.module';
import { QuillService } from 'src/app/services/quill.service';

@Component({
  selector: 'app-report-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    QuillModule,
  ],
})
export class ReportNoteComponent implements AfterViewInit {
  private formBuilder = inject(FormBuilder);
  private quillService = inject(QuillService);

  text = input.required<string>();

  modules = computed(() => this.quillService.modules());
  formGroup = this.formBuilder.group({
    editorContent: ['', Validators.required],
  });

  ngAfterViewInit(): void {
    this.formGroup.get('editorContent').setValue(this.text());
  }

  getEditorInstance(editorInstance: Quill) {
    this.quillService.setRef(editorInstance);
  }
}
